import { LoadingDots } from "PFComponents/loading_dots";
import { Pill } from "PFComponents/pill";
import { useActivityVacancies } from "PFCore/hooks/queries/activity";
import { Activity } from "PFTypes";

type RoleVacanciesBadgeProps = {
  role: Activity;
};

export const RoleVacanciesBadge = ({ role }: RoleVacanciesBadgeProps) => {
  const { data: vacancies, isLoading } = useActivityVacancies(
    {
      activityId: role.id,
      perPage: 0
    },
    {
      enabled: role.coowned
    }
  );

  if (isLoading) {
    return <LoadingDots />;
  }

  if (!role.coowned || !vacancies) {
    return null;
  }

  const message = `${vacancies.meta.totalOpened} / ${vacancies.meta.total}`;

  return <Pill small text={message} />;
};
